import React from 'react';
import {
  ForgotPasswordPageProps,
  ForgotPasswordFormTypes,
  useTranslate,
  useForgotPassword,
  useRouterType,
  useLink,
  useRouterContext,
} from '@refinedev/core';
import { ThemedTitle } from '../../../themedLayout/title';
import {
  layoutStyles,
  containerStyles,
  titleStyles,
  headStyles,
  bodyStyles,
  buttonStyle,
  PageTitleStyles,
} from './styles';
import './style.css';
import {
  Row,
  Col,
  Layout,
  Card,
  Typography,
  Form,
  Input,
  Button,
  LayoutProps,
  CardProps,
  FormProps,
  theme,
  Divider,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import {
  clearFieldErrorMessageOnChange,
  onlyLatinCharsDigitsSpecialSymbolsRule,
} from '../../../../utils/form.constants';

type ResetPasswordProps = ForgotPasswordPageProps<LayoutProps, CardProps, FormProps>;

const { Title } = Typography;
const { useToken } = theme;
export const ForgotPasswordPage: React.FC<ResetPasswordProps> = ({
  wrapperProps,
  contentProps,
  renderContent,
  formProps,
  title,
}) => {
  const { token } = useToken();
  const [form] = Form.useForm<ForgotPasswordFormTypes>();
  const translate = useTranslate();
  const routerType = useRouterType();
  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const { mutate: forgotPassword, isLoading } = useForgotPassword<ForgotPasswordFormTypes>();

  const ActiveLink = routerType === 'legacy' ? LegacyLink : Link;

  const PageTitle =
    title === false ? null : (
      <div
        style={{
          ...PageTitleStyles,
        }}
      >
        {title ?? <ThemedTitle collapsed={false} />}
      </div>
    );

  const CardHeader = (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <ActiveLink
        style={{
          color: token.colorPrimaryTextHover,
          fontSize: '14px',
          lineHeight: '22px',
          textAlign: 'left',
        }}
        to='/login'
      >
        <ArrowLeftOutlined className='site-form-item-icon' style={{ marginRight: '10px' }} />
        {translate('pages.login.buttons.Registration', 'Back')}
      </ActiveLink>
      <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
      <Title
        level={3}
        style={{
          color: token.colorPrimaryTextHover,
          ...titleStyles,
        }}
      >
        {translate('pages.forgotPassword.title', 'Forgot password')}
      </Title>
    </div>
  );

  const CardContent = (
    <Card
      title={CardHeader}
      headStyle={headStyles}
      bodyStyle={bodyStyles}
      style={{
        ...containerStyles,
      }}
      {...(contentProps ?? {})}
    >
      <Form<ForgotPasswordFormTypes>
        layout='vertical'
        form={form}
        onFinish={forgotPassword}
        requiredMark={false}
        {...formProps}
        onValuesChange={clearFieldErrorMessageOnChange(form)}
      >
        <Form.Item
          name='email'
          className='testClassName'
          style={{ marginTop: '-15px' }}
          rules={[
            onlyLatinCharsDigitsSpecialSymbolsRule,
            { required: true, validateTrigger: 'onSubmit' },
            {
              type: 'email',
              message: translate('pages.forgotPassword.errors.validEmail', 'Invalid email address'),
              validateTrigger: 'onSubmit',
            },
          ]}
        >
          <Input
            type='email'
            size='large'
            placeholder={translate('pages.forgotPassword.fields.email', 'Email')}
            style={{
              ...buttonStyle,
            }}
          />
        </Form.Item>
        <Row>
          <Col span={10} offset={7}>
            <Form.Item
              style={{
                marginTop: '24px',
                marginBottom: 0,
              }}
            >
              <Button
                type='primary'
                size='large'
                htmlType='submit'
                loading={isLoading}
                block
                style={{
                  ...buttonStyle,
                  marginBottom: '10px',
                  marginTop: '-10px',
                }}
              >
                {translate('pages.forgotPassword.buttons.submit', 'Reset password')}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );

  return (
    <Layout style={layoutStyles} {...(wrapperProps ?? {})}>
      <Row
        justify='center'
        align='middle'
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          {renderContent ? (
            renderContent(CardContent, PageTitle)
          ) : (
            <>
              {PageTitle}
              {CardContent}
            </>
          )}
        </Col>
      </Row>
    </Layout>
  );
};
